<template>
  <div class="form-row align-items-start">
    <div class="form-group col-md-3 mb-3">
      <BaseInputForm
        label="Keyword"
        placeholder="Ex. Opportunity name, country or location"
        :disabled="isSearching"
        v-model="keyword"
        @keyup.enter="search" />
    </div>
    <div class="form-group col-md-2 mb-2 ">
      <button
        v-if="keyword"
        class="btn btn-md btn-outline-hover-secondary mtop"
        :class="{ 'disabled': isSearching || !keyword }"
        :disabled="isSearching || !keyword"
        @click="resetSearch">Reset search</button>
    </div>
  </div>
</template>

<script>
import config from '@/config'

export default {
  name: 'OpportunityListSearch',
  data () {
    return {
      keyword: ''
    }
  },
  props: {
    isSearching: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    cleanSearch () {
      this.keyword = ''
    },
    resetSearch () {
      const params = {
        limit: config.opportunityList.pagination.byPage,
        offset: 0,
        query: ''
      }
      this.cleanSearch()
      this.$emit('onResetSearch', params)
    },
    search () {
      const params = {
        limit: config.opportunityList.pagination.byPage,
        offset: 0,
        query: this.keyword
      }
      this.$emit('onSearch', params)
    }
  }
}
</script>

<style lang="scss" scoped>
.mtop {
  margin-top: 25px;
}
</style>
